/* eslint-disable */
import { axiosClient, initI18n } from 'www/utils';

(async function IIFE() {
    const $triggerElement = $('.b-clinic-promotions-header__subtitle_js');

    if (!$triggerElement.length) return;

    const { i18next, userLanguage } = await initI18n({ bundle: 'doctors.blocks/common/b-clinic-promotions-header' })

    const baseUrl = $triggerElement.data('archive-url');
    if (baseUrl === '') return;

    $triggerElement.click('click', () => {
        axiosClient.get(baseUrl)
            .then(res => {
                const commonTemplate = `
                    <div class="b-promotions-popup mfp-with-anim">
                        <div class="b-promotions-popup__header">
                            <div class="b-promotions-popup__title">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.94598 3.98199C7.61147 3.98199 7.29067 4.11487 7.05413 4.3514C6.8176 4.58793 6.68472 4.90874 6.68472 5.24325C6.68472 5.57776 6.8176 5.89857 7.05413 6.1351C7.28819 6.36916 7.60478 6.50173 7.9355 6.50447H10.6554C10.555 6.25391 10.433 5.98602 10.2871 5.72083C9.72576 4.70017 8.97147 3.98199 7.94598 3.98199ZM4.70273 5.24325C4.70273 5.68073 4.79112 6.10909 4.95801 6.50447H2.99099C2.44368 6.50447 2 6.94815 2 7.49546V12C2 12.5473 2.44368 12.991 2.99099 12.991H3.80186V21.009C3.80186 21.5563 4.24554 22 4.79285 22H11.9905L12.0001 22L12.0096 22H19.2073C19.7546 22 20.1983 21.5563 20.1983 21.009V12.991H21.0091C21.5564 12.991 22 12.5473 22 12V7.49546C22 6.94815 21.5564 6.50447 21.0091 6.50447H19.0421C19.209 6.10909 19.2974 5.68073 19.2974 5.24325C19.2974 4.38309 18.9557 3.55815 18.3474 2.94993C17.7392 2.3417 16.9143 2 16.0541 2C13.951 2 12.6832 3.49883 12.0001 4.72286C11.3169 3.49883 10.0491 2 7.94598 2C7.08582 2 6.26088 2.3417 5.65266 2.94993C5.04443 3.55815 4.70273 4.38309 4.70273 5.24325ZM16.0646 6.50447H13.3447C13.4451 6.25391 13.5671 5.98602 13.713 5.72083C14.2743 4.70017 15.0286 3.98199 16.0541 3.98199C16.3886 3.98199 16.7094 4.11487 16.946 4.3514C17.1825 4.58793 17.3154 4.90874 17.3154 5.24325C17.3154 5.57776 17.1825 5.89857 16.946 6.1351C16.7119 6.36916 16.3953 6.50173 16.0646 6.50447ZM12.991 8.4865V11.009H19.1979L19.2073 11.0089L19.2167 11.009H20.0181V8.48646H16.0709C16.0653 8.48649 16.0597 8.4865 16.0541 8.4865H12.991ZM3.98199 8.48646H7.92918L7.94598 8.4865H11.0091V11.009H4.80223L4.79285 11.0089L4.78347 11.009H3.98199V8.48646ZM12.991 20.018H18.2163V12.991H12.991V20.018ZM11.0091 12.991V20.018H5.78385V12.991H11.0091Z" fill="#CCCCCC"/>
                                </svg>
                                ${i18next.t('Архивные акции', { ns: userLanguage })}
                            </div>
                            <button type="button" class="b-promotions-popup__close mfp-close">×</button>
                        </div>
                        <div class="b-promotions-popup__body">
                            ${res.data}
                        </div>
                    </div>
                `;

                $triggerElement.magnificPopup({
                    removalDelay: 200,
                    overflowY: 'scroll',
                    items: {
                        src: commonTemplate,
                        type: 'inline'
                    },
                    callbacks: {
                        beforeOpen: function () {
                            this.st.mainClass = 'mag-popup';
                            this.st.mainClass += ' ' + $triggerElement.attr('data-effect');
                        },
                        open: function () {
                            $(document).delegate('.b-promotions-popup .b-pagination a', 'click', updatePage);
                        },
                        close: function () {
                            $(document).undelegate('.b-promotions-popup .b-pagination a', 'click', updatePage);

                        }
                    }
                }).magnificPopup('open');
            });

        function updatePage (evt) {
            evt.preventDefault();
            let url = $(this).attr('href');

            if (!/\/.+\//.test(url)) {
                url = baseUrl + url;
            }

            axiosClient.get(url)
                .then(res => {
                    $('.b-promotions-popup__body')
                        .html(res.data)
                        .scrollTop(0)
                })
        }
    })
})();
